module.exports = __webpack_public_path__ + "img/almond.a249704f.png";